//@ts-check
import addDesignTrunk from './addDesignTrunk';
import getHost from '../host';
import FolderThumbnail from './folderThumbnail.png';
/**
 * @type {import("./types").getFileThumbnailPathType}
 */

export default (function (_ref) {
  var workspace = _ref.workspace,
      path = _ref.path,
      token = _ref.token;
  var host = getHost() || '/'; // if not host, ensure that we have a valid url

  if (path.indexOf(':') > -1) return "".concat(host, "backend/preview?resourceToken=").concat(token, "&workspace=").concat(encodeURIComponent(workspace), "&path=").concat(encodeURIComponent(path), "&type=thumbnail");

  if (path.indexOf('.') > -1) {
    //file
    var svPath = addDesignTrunk(path);
    svPath = svPath.split('/').join('\\');
    return "".concat(host, "backend/preview?resourceToken=").concat(token, "&workspace=").concat(encodeURIComponent(workspace), "&path=").concat(encodeURIComponent(svPath), "&type=thumbnail");
  } else {
    //folder
    return FolderThumbnail;
  }
});